import React from 'react';
import {Row, Col, Input } from 'antd'
import { useTranslation } from 'react-i18next';

const ContactoFacturacion = ({contactoFacturacion={}, record, actual}) => {
    const { t } = useTranslation();
    return (
        <div>
            <Row gutter={[32, 12]}>
                <Col span={6}>
                {t("messages.aml.fullName")}
                <Input readOnly value={contactoFacturacion.nombreFacturacion} className={actual && contactoFacturacion.nombreFacturacion !== actual.nombreFacturacion && "difference"}/>
                </Col>
                <Col span={6}>
                {t("messages.aml.email")}
                <Input readOnly value={contactoFacturacion.mailFacturacion} className={actual && contactoFacturacion.mailFacturacion !== actual.mailFacturacion && "difference"}/>
                </Col>
                <Col span={6}>
                {t("messages.aml.mobilePhone")}
                <Input readOnly value={contactoFacturacion.celFacturacion} className={actual && contactoFacturacion.celFacturacion !== actual.celFacturacion && "difference"}/>
                </Col>
                <Col span={6}>
                {t("messages.aml.landline")}
                <Input readOnly value={contactoFacturacion.telFacturacion} className={actual && contactoFacturacion.telFacturacion !== actual.telFacturacion && "difference"}/>
                </Col>
                {record.type === 'Entity' &&
                    <Col span={6}>
                        {t("messages.aml.position")}
                        <Input readOnly value={contactoFacturacion.cargoFacturacion} className={actual && contactoFacturacion.cargoFacturacion !== actual.cargoFacturacion && "difference"}/>
                    </Col>
                }
            </Row>
        </div>
    );
};

export default ContactoFacturacion;